import styled from "@emotion/styled";
import { FollowUsOnFacebook } from "scmp-sdk/components/follow-us-on-facebook";
import { FacebookIframe } from "scmp-sdk/components/follow-us-on-facebook/styles";

import { fontMerriweather, fontRoboto, theme } from "shared/lib/styles";

import IconTickCircle from "./icon-tick-circle.svg";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
`;

export const StyledIconTickCircle = styled(IconTickCircle)`
  flex-shrink: 0;

  inline-size: 25px;
  block-size: 25px;
`;

export const Title = styled.div`
  font-weight: 700;
  font-size: 18px;
  font-family: ${fontMerriweather};
  line-height: normal;
  text-align: start;
`;

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const InnerContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;

  inline-size: 100%;

  ${theme.breakpoints.down("tablet")} {
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
  }
`;

export const Divider = styled.div`
  inline-size: 100%;
  block-size: 1px;

  background-color: rgba(0, 0, 0, 0.2);

  ${theme.breakpoints.up("tablet")} {
    flex-shrink: 0;
    align-self: center;

    inline-size: 1px;
    block-size: 66px;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;

  ${theme.breakpoints.up("tablet")} {
    flex-direction: row;
    gap: 16px;
    align-items: center;

    padding-inline-end: 24px;
  }
`;

export const StyledFollowUsOnFacebook = styled(FollowUsOnFacebook)`
  display: block;

  ${theme.breakpoints.up("tablet")} {
    display: flex;
    gap: 8px;
    align-items: center;

    /* Push the whole block to the right edge, matching Figma. */
    margin-inline-start: auto;
  }

  ${FacebookIframe} {
    inline-size: 86px;
    margin-inline-start: 0;

    ${theme.breakpoints.down("tablet")} {
      margin-block-start: 4px;
    }
  }
`;

export const CheckEmailMessage = styled.div`
  margin-block-start: 8px;

  color: #000000;
  font-size: 12px;
  font-family: ${fontRoboto};
  line-height: normal;
  text-align: start;

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 4px;
  }
`;
